import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import Crop from '@spectrum-icons/workflow/Crop';
import Gradient from '@spectrum-icons/workflow/Gradient';
import Resize from '@spectrum-icons/workflow/Resize';
import { EditorActions } from 'app/stores/editor/actions';
import { getActiveTool } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { getToolIcon } from 'app/views/components/editor/pickers/ToolIcon';
import { Button } from 'app/views/components/editor/sidebar/Button';
import { Divider } from 'app/views/components/editor/sidebar/Divider';
import { useConnect } from 'app/views/hooks/useConnect';
import { analytics } from 'app/utils/analytics';
const GapValues = {
    row: 'size-75',
    column: 'size-175',
};
// NOTE: add image on tool selection
// const ImageButton = (props: ButtonProps) => {
//     const { onPress: _, ...otherProps } = props;
//     // const dispatch = useAppDispatch();
//     const onSelectFiles = React.useCallback<
//         ReturnType<typeof getDefaultFileSelectHandler>
//     >((files, source) => {
//         console.log(files, source);
//         // getDefaultFileSelectHandler(dispatch)(files, source);
//         // call(onSelect);
//     }, []);
//     return (
//         <FilePickerBase className="btn-large" onSelect={onSelectFiles}>
//             {open => <Button onPress={open} {...otherProps} />}
//         </FilePickerBase>
//     );
// };
const MarkerRenderer = {
// image: ImageButton,
};
export const ToolPicker = (props) => {
    const { direction = 'column' } = props;
    const dispatch = useAppDispatch();
    const desktopMainViewLayout = configGet('desktopMainViewLayout', 'row');
    const enableResize = hasFeature('enableResize');
    const enableBackgrounds = hasFeature('enableBackgrounds');
    const stateProps = useConnect(state => ({
        tools: state.editor.availableTools,
        activeTool: getActiveTool(state),
    }));
    const { tools, activeTool } = stateProps;
    const onToolAction = React.useCallback((toolId) => {
        if (toolId) {
            if ((activeTool === null || activeTool === void 0 ? void 0 : activeTool.alias) !== toolId) {
                analytics({
                    action: 'ToolPicker',
                    label: `select:${toolId}`,
                    category: toolId,
                });
                dispatch(EditorActions.setActiveTool(toolId));
            }
        }
        else {
            analytics({
                action: 'ToolPicker',
                label: 'clearTool',
            });
            dispatch(EditorActions.clearTool());
        }
    }, [activeTool, dispatch]);
    const showCropper = React.useCallback(() => {
        analytics({
            action: 'ToolPicker',
            label: 'select:ImageCrop',
        });
        dispatch(EditorActions.showImageCropper());
    }, [dispatch]);
    const showBackgroundEditor = React.useCallback(() => {
        analytics({
            action: 'ToolPicker',
            label: 'select:ImageBackground',
        });
        dispatch(EditorActions.showImageBackground());
    }, [dispatch]);
    return (React.createElement(Flex, { width: "100%", direction: direction, gap: GapValues[desktopMainViewLayout] },
        tools.map(tool => {
            var _a, _b;
            const label = (_a = tool.label) !== null && _a !== void 0 ? _a : tool.alias;
            const Icon = getToolIcon(tool);
            const ButtonRenderer = (_b = MarkerRenderer[tool.id]) !== null && _b !== void 0 ? _b : Button;
            return (React.createElement(ButtonRenderer, { key: tool.id, isSelected: tool.id === (activeTool === null || activeTool === void 0 ? void 0 : activeTool.id), label: label, Icon: Icon, "data-test-id": `toolbar-btn-${tool.id}`, isToggle: true, onPress: () => onToolAction(tool.id) }));
        }),
        React.createElement(Button, { label: "Crop", Icon: Crop, onPress: showCropper }),
        (enableResize || enableBackgrounds) && React.createElement(Divider, null),
        enableResize && (React.createElement(Button, { label: "Size", Icon: Resize, onPress: showCropper })),
        enableBackgrounds && (React.createElement(Button, { label: "Background", Icon: Gradient, onPress: showBackgroundEditor }))));
};
